// import { Userpilot } from 'userpilot' // << just a link for your reference to review existing userpilot functionality

export interface UserPilotHelpers {
  clickSettingsMainNav: () => void
  expandRulesAndWorkflowSection: (advance?: boolean) => Promise<void>
}

type userPilotFunc = { close?: () => void; next?: () => void } | undefined

// all custom functions go in here :)
export const userPilotHelpers = {
  clickSettingsMainNav: () => {
    // first, close the current tool tip so it doesn't interact with anything
    const up = window.userpilot as userPilotFunc
    up?.close?.()

    // click settings
    const settingsNav = document.querySelector(
      '[data-testid="mainNavSettings"]',
    ) as HTMLElement
    settingsNav?.click()

    // wait for it to open (by presence of 'back' at top)
    const checkNav = setInterval(() => {
      const navOpened = document.querySelector(
        '[data-testid="profileSettingsNavBack"]',
      )

      if (navOpened) {
        clearInterval(checkNav)
      }
    }, 100)
  },

  expandRulesAndWorkflowSection: async (advance = false): Promise<void> => {
    // first, close the current tool tip so it doesn't interact with anything
    const up = window.userpilot as userPilotFunc
    up?.close?.()

    // if necessary, click the section to expand
    const isSectionOpen = document.querySelector(
      '[data-testid="navgroup-settingsNavRulesAndWorkflows"][data-isexpanded="true"]',
    ) as HTMLElement | null

    if (!isSectionOpen) {
      const rulesAndWorkflowSection = document.querySelector(
        '[data-testid="settingsNavRulesAndWorkflows"]',
      ) as HTMLElement | null
      rulesAndWorkflowSection?.click()

      await new Promise((resolve) => setTimeout(resolve, 500))
    }

    // scroll down nav
    const container = document.querySelector(
      '[data-testid="sidenav-scrollable-content"]',
    )

    if (container) {
      container.scrollTo({
        top: container.scrollHeight,
        behavior: 'smooth',
      })
      await new Promise((resolve) => setTimeout(resolve, 300))
    }

    if (advance) {
      up?.next?.()
    }
  },
}
